<div #dropdown>
    <button
        appNavItem
        appMenuButton
        [position]="position"
        [dropdownEl]="dropdown"
        [ariaControls]="listId"
        type="button"
        class="tw-flex tw-items-center tw-flex-col tw-gap-2"
        buttonDataTest="helpDropdownButton"
    >
        <app-icon name="info" class="tw-size-5 tw-transition-colors tw-duration-[400ms]" [ngClass]="(open$ | async) ? 'tw-fill-primary' : ''" />
        <div class="tw-flex tw-items-center tw-gap-1">
            <span class="nav-item-text" [ngClass]="(open$ | async) ? 'tw-text-primary' : ''">{{ 'v3-global-help' | translate }}</span>
            <app-icon
                class="tw-size-3 tw-transition-transform tw-duration-[400ms]"
                [ngClass]="(open$ | async) ? 'tw-rotate-180 tw-fill-primary' : ''"
                name="point-arrow-down"
            />
        </div>
    </button>

    <app-nav-item-help-list [open]="open$ | async" />
</div>
